export default "__VITE_ASSET__D20s6QBM__"